import { createSlice } from '@reduxjs/toolkit'

export const loginSlice=createSlice({
    name: 'admin',
    initialState: {
        admin:localStorage.getItem('adminData') ?JSON.parse(localStorage.getItem('adminData')):{},
        permission:[]
    },
      reducers:{
        updateLoginData:(state,payload)=>{
            state.admin=payload.payload
        },
        checkLogin: (state) => {
            return state?.admin?.id && state?.admin?.token;
          },
        logout:(state)=>{
            state.admin={}
        },
        addPermission:(state,action)=>{
          state.permission=action.payload
        }
      }
})

export const { updateLoginData,checkLogin,logout,addPermission } = loginSlice.actions

export default loginSlice.reducer